import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as CoreActions from '@app/core/store/core.action';
import { selectCoreState, selectIsNavOpen } from '@app/core/store/core.selectors';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';
import { DeleteRoleShowErrorMessage } from '../../store/selectors/role.selectors';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import * as RoleActions from '@app/modules/roles/store/actions/role.actions';

@Component({
  selector: 'app-delete-role-modal',
  templateUrl: './delete-role-modal.component.html',
  styleUrls: ['./delete-role-modal.component.scss']
})

export class DeleteRoleModalComponent implements OnInit {
  public user_count: number;
  public current_role_id: number;
  public role_list: any;
  public form: FormGroup;

  constructor(
    public fb: FormBuilder,
    private store$: Store,
    private _translation: TranslateService,
    private _matDialog: MatDialog,
    private router: Router
  ) { 

    this.form = this.fb.group({
      usrRoles: new FormControl('')
    });
  
  }

  ngOnInit(): void {
    this.store$.select(DeleteRoleShowErrorMessage).subscribe(errorMessage => {
      this.user_count = errorMessage?.user_count ?? '';
      this.current_role_id = errorMessage?.current_role_id ?? '';
      this.role_list = errorMessage?.role_list ?? '';
    });
  }

  onSubmit() {
    let data = this.store$.dispatch(RoleActions.AssignNewRoles({ current_role_id:this.current_role_id, new_role_ids:this.form.value.usrRoles }));
    this._matDialog.closeAll();
  }

  isValid(form) {
    if (form.valid == false) {
      return true;
    }

    form.markAsPristine();
    return false;
  }

}

